(function ($) {

    var $inlineArticleImages = $('.article-page .page-base__main__body img');

	$inlineArticleImages.each(function () {
        var $this = $(this);

        if ($this.hasClass('high-res-image-block__image')) {
	        $this.css('padding', 0);
            return;
        }

		var float = $this.css('float');
		if (float === 'right') {
			$this.css('padding-right', 0);
		} else if (float === 'left') {
			$this.css('padding-left', 0);
		} else {
			$this.css('padding', 0);
		}
	});

})(jQuery);
